import { StoreModel, Action } from '../types';
import { counterReducer, getCounterInitialState } from './counter/reducer';
import { getQSGInitialState, qsgReducer } from './qsg/reducer';

export const getInitialState = (): StoreModel => ({
  counter: getCounterInitialState(),
  qsg: getQSGInitialState(),
});

export const rootReducer = (state: StoreModel, action: Action): StoreModel => ({
  counter: counterReducer(state.counter, action),
  qsg: qsgReducer(state.qsg, action),
});
